import { Button } from "@blueprintjs/core";

type SchedulerTogglePillsProps<T extends number> = {
  disabled?: boolean;
  options: { value: T; label: string; title?: string }[];
  selected: T[];
  onChange: (selected: T[]) => void;
};

export function SchedulerTogglePills<T extends number>({
  disabled,
  onChange,
  options,
  selected,
}: SchedulerTogglePillsProps<T>) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((option) => {
        const isSelected = selected.includes(option.value);

        return (
          <Button
            active={isSelected}
            // Pill shape comes from `.scheduler-pill` in index.css; color
            // comes from `intent="primary"`, which already resolves to the
            // brand green via the --bp-intent-primary-* overrides there --
            // no need to hardcode brand-green-dark/white here.
            className="scheduler-pill"
            disabled={disabled}
            intent={isSelected ? "primary" : "none"}
            key={option.value}
            minimal={!isSelected}
            onClick={() =>
              onChange(
                isSelected
                  ? selected.filter((value) => value !== option.value)
                  : [...selected, option.value],
              )
            }
            small
            title={option.title}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
